import { getKimpleFolder, getAllByLocaleKimpleFolders, copyKimpleFolder, getUsersFromMySchoolsGroup, shareKimpleFolder, getRedirectedKimpleFolder } from '../../services/KimpleFolderService'

import { isError, isRedirection } from '../../utils/api'

import router, { routes } from '../../router'

export default {
  state: {
    kimpleFolderDetail: {},
    kimpleFolders: [],
    kimpleFoldersLoading: false,
    usersInMySchoolsGroup: [],
    redirectedKimpleFolder: false
  },

  mutations: {
    setKimpleFolder(state, kimpleFolder) {
      state.kimpleFolderDetail = kimpleFolder
    },
    setKimpleFolders(state, status) {
      state.kimpleFolders = status.data
    },
    setLoadingKimpleFolders(state, status) {
      state.kimpleFoldersLoading = status
    },
    hydrateUsersFromMySchoolsGroup(state, users) {
      state.usersInMySchoolsGroup = users
    },
    clearUsersFromMySchoolsGroup(state) {
      state.usersInMySchoolsGroup = []
    },
    setRedirectedKimpleFolder(state, status) {
      state.redirectedKimpleFolder = status
    },
    clearRedirectedKimpleFolder(state) {
      state.redirectedKimpleFolder = false
    }
  },

  actions: {
    async getKimpleFolderDetails({ commit }, payload) {
      const { id, locale } = payload
      commit('clearRedirectedKimpleFolder')
      commit('show', { element: 'fullPageLoader' })
      const response = await getKimpleFolder(id, locale).catch(e => e.response)
      if (isError(response.status)) {
        router.push({ name: routes.notFound })
      } else if (isRedirection(response.status)) {
        const redirectedResponse = await getRedirectedKimpleFolder(response.data.value).catch(e => e.response)
        commit('setRedirectedKimpleFolder', true)
        commit('setKimpleFolder', redirectedResponse.data)
      } else {
        commit('setKimpleFolder', response.data)
      }
      commit('hide', { element: 'fullPageLoader' })
    },
    async hydrateKimpleFolders({ commit }, payload) {
      commit('show', { element: 'fullPageLoader' })
      commit('setLoadingKimpleFolders', true)
      getAllByLocaleKimpleFolders(payload).then(response => {
        commit('setKimpleFolders', response.data)
        commit('hide', { element: 'fullPageLoader' })
        commit('setLoadingKimpleFolders', false)
      })
    },
    async copyKimpleFolder({ commit }, { id, locale }) {
      const response = await copyKimpleFolder({ id, locale }).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      return successfulRequest
    },
    async hydrateUsersFromMySchoolsGroup({ commit }) {
      const response = await getUsersFromMySchoolsGroup().catch(e => e.response)
      const successfulRequest = !isError(response.status)
      if (successfulRequest) commit('hydrateUsersFromMySchoolsGroup', response.data)
      return successfulRequest
    },
    async shareKimpleFolder({ commit }, { folderId, recipients, locale, folderLocale }) {
      const response = await shareKimpleFolder({ folderId, recipients, locale, folderLocale }).catch(e => e.response)
      const successfulRequest = !isError(response.status)
      return successfulRequest
    },
    clearUsersFromMySchoolsGroup({ commit }) {
      commit('clearUsersFromMySchoolsGroup')
    }
  }
}
